import { useEffect } from "react";
export default function useReportError(error) {
    useEffect(() => {
        if (error != null) {
            reportError(error);
        }
    }, [error]);
}
